module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "program",
    class: [
      'epg__timeslot',
      'epg__slot-event', {
        'is-empty': _vm.program._emptySlot,
        'is-small': _vm.program._duration < 15,
        'is-before': _vm.program._isBeforeNow && !_vm.program._isLive,
        'is-live': _vm.program._isLive,
        'in-viewport': _vm.inViewport,
        'epg__timeslot--selected': _vm.program._isSelected
      }
    ],
    style: (("width:" + (_vm.pixelsPerMinute * _vm.program._duration) + "px!important"))
  }, [_c('div', {
    class: ['epg__slot-basic-info', {
      // 'epg__slot-basic-info--right': !titleInViewport
    }],
    on: {
      "click": function($event) {
        _vm.selectProgram(_vm.program)
      }
    }
  }, [(_vm.program._duration > 4) ? _c('span', {
    ref: "title"
  }, [_vm._v(_vm._s(_vm.program.title))]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.program._duration > 4) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.program._start.format('H:mm'))
    }
  }) : _vm._e(), _vm._v("\n            -\n            "), (_vm.program._duration > 4) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.program._end.format('H:mm'))
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.program._isSelected) ? _c('div', {
    staticClass: "epg__slot-more-info",
    style: (("left:" + (-_vm.containerPos) + "px; width:" + _vm.timelineWidth + "px"))
  }, [_c('SelectedSlot', {
    attrs: {
      "description-truncation-point": _vm.descriptionTruncationPoint,
      "more-label": _vm.moreLabel,
      "less-label": _vm.lessLabel,
      "close-slot": _vm.closeSlot,
      "set-expanded-slot-height": _vm.setExpandedSlotHeight,
      "expanded-slot-height": _vm.expandedSlotHeight,
      "show-program-loader": _vm.showProgramLoader,
      "selected-program": _vm.selectedProgram
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7516c64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Program/Program.vue
// module id = 235
// module chunks = 1